import React, { useEffect, useState } from "react";
import { Form, Input, Button, Select, Row, Col, Upload, Typography, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";

const { Option } = Select;
const { Title } = Typography;

const VehiclesForm = ({ formData, setFormData, closeModal, setSubmitted }) => {
  const [form] = Form.useForm();
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [owners, setOwners] = useState([]); // State to store owners
  const [vehicleImageFile, setVehicleImageFile] = useState([]);
  const [documentsFile, setDocumentsFile] = useState([]);

  useEffect(() => {
    fetchVehicleTypes();
    fetchDrivers();
    fetchOwners(); // Fetch owners when the component loads
  }, []);

  useEffect(() => {
    if (formData) {
      form.setFieldsValue(formData);
      if (formData.vehicleImage) {
        setVehicleImageFile([
          {
            uid: "-1",
            name: "Uploaded Vehicle Image",
            status: "done",
            url: formData.vehicleImage,
          },
        ]);
      }
      if (formData.documents) {
        setDocumentsFile([
          {
            uid: "-1",
            name: "Uploaded Documents",
            status: "done",
            url: formData.documents,
          },
        ]);
      }
    }
  }, [formData, form]);

  const fetchVehicleTypes = async () => {
    try {
      const response = await axios.get("http://93.127.203.113:5005/vehicleTypes");
      setVehicleTypes(response.data);
    } catch (error) {
      message.error("Unable to load vehicle types");
    }
  };

  const fetchDrivers = async () => {
    try {
      const response = await axios.get("http://93.127.203.113:5005/drivers");
      setDrivers(response.data);
    } catch (error) {
      message.error("Unable to load drivers");
    }
  };

  const fetchOwners = async () => {
    try {
      const response = await axios.get("http://93.127.203.113:5005/owners");
      setOwners(response.data);
    } catch (error) {
      message.error("Unable to load owners");
    }
  };

  const handleFileChange = (fileList, setter) => {
    setter(fileList.fileList);
  };

  const onFinish = async (values) => {
    const submitData = new FormData();

    // Append form fields
    Object.keys(values).forEach((key) => {
      submitData.append(key, values[key]);
    });

    // Append files
    if (vehicleImageFile.length) {
      submitData.append("vehicleImage", vehicleImageFile[0].originFileObj);
    }
    if (documentsFile.length) {
      submitData.append("documents", documentsFile[0].originFileObj);
    }

    try {
      let response;
      if (formData.id) {
        // Update vehicle
        response = await axios.put(
          `http://93.127.203.113:5005/vehicles/${formData.id}`,
          submitData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
      } else {
        // Create new vehicle
        response = await axios.post("http://93.127.203.113:5005/vehicles", submitData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      message.success("Vehicle saved successfully");
      setFormData({});
      closeModal();
      setSubmitted(true); // Trigger refetch after successful form submission
    } catch (error) {
      console.error("Error:", error);
      message.error("Failed to save vehicle");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <Title
        level={4}
        style={{
          color: "#0c8c49",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        {formData.id ? "Edit Vehicle" : "Add Vehicle"}
      </Title>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              label="Plate Number"
              name="plateNumber"
              rules={[{ required: true, message: "Please enter a plate number" }]}
            >
              <Input placeholder="Enter plate number" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Model"
              name="model"
              rules={[{ required: true, message: "Please enter a model" }]}
            >
              <Input placeholder="Enter vehicle model" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              label="Color"
              name="color"
              rules={[{ required: true, message: "Please enter a color" }]}
            >
              <Input placeholder="Enter vehicle color" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Manufactured Year"
              name="manufacturedYear"
              rules={[
                { required: true, message: "Please enter the manufactured year" },
              ]}
            >
              <Input placeholder="Enter manufactured year" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              label="Vehicle Type"
              name="vehicleTypeId"
              rules={[{ required: true, message: "Please select a vehicle type" }]}
            >
              <Select placeholder="Select vehicle type">
                {vehicleTypes.map((type) => (
                  <Option key={type.id} value={type.id}>
                    {type.typeName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Driver"
              name="driverId"
              rules={[{ required: true, message: "Please select a driver" }]}
            >
              <Select placeholder="Select driver">
                {drivers.map((driver) => (
                  <Option key={driver.id} value={driver.id}>
                    {`${driver.firstName} ${driver.lastName}`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              label="Owner"
              name="ownerId"
              rules={[{ required: true, message: "Please select an owner" }]}
            >
              <Select placeholder="Select owner">
                {owners.map((owner) => (
                  <Option key={owner.id} value={owner.id}>
                    {owner.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Status" name="status">
              <Select placeholder="Select status">
                <Option value="Pending">Pending</Option>
                <Option value="Active">Active</Option>
                <Option value="Inactive">Inactive</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item label="Vehicle Image">
              <Upload
                listType="picture"
                fileList={vehicleImageFile}
                onChange={(fileList) =>
                  handleFileChange(fileList, setVehicleImageFile)
                }
                beforeUpload={() => false}
              >
                <Button icon={<UploadOutlined />}>Upload Vehicle Image</Button>
              </Upload>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Documents">
              <Upload
                listType="picture"
                fileList={documentsFile}
                onChange={(fileList) =>
                  handleFileChange(fileList, setDocumentsFile)
                }
                beforeUpload={() => false}
              >
                <Button icon={<UploadOutlined />}>Upload Documents</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Button
            type="primary"
            htmlType="submit"
            style={{
              backgroundColor: "#0c8c49",
              borderColor: "#0c8c49",
              marginRight: "10px",
            }}
          >
            Save
          </Button>
          <Button
            htmlType="button"
            onClick={() => form.resetFields()}
            style={{
              color: "#0c8c49",
              borderColor: "#0c8c49",
            }}
          >
            Reset
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default VehiclesForm;
